import { createRoot } from "react-dom/client";

import FloatingBar from "./FloatingBar";
import { FLOATING_BAR_ID } from "./constants";

const container = document.getElementById(FLOATING_BAR_ID);
const root = createRoot(container!);

root.render(<FloatingBar />);
